import React from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    IconButton,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import styled from "styled-components";
import { Save } from "@mui/icons-material";
import request from "src/utils/request";
import Auth from "../../services/auth";

const SectionTitle = styled.h2`
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const CardContainer = styled(Paper)`
    border-radius: 14px;
    border: ${({ theme, result }) => {
        if (result === "pending") return `2px solid ${theme.palette.text.disabled}`;
        if (result === "success") return `2px solid ${theme.palette.success.main}`;
        if (result === "failure") return `2px solid ${theme.palette.error.main}`;
        return `2px solid transparent`;
    }};
`;

const SubText = styled(Typography)`
    font-size: 12px;
    color: ${({ theme }) => theme.palette.text.disabled};
`;

const SectionTitleIcon = styled(Stack)`
    height: 22px;
    width: 22px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 2px;
`;

const MfaSettingsCard = ({ user, updateUser }) => {
    if (!user) return null;
    const currentUserMfa = user && !!user.useMfa;
    const [mfaEnabled, setMfaEnabled] = React.useState(currentUserMfa);
    const [saveResult, setSaveResult] = React.useState();

    React.useEffect(() => {
        setTimeout(() => {
            if (saveResult === "success" || saveResult === "failure") setSaveResult(undefined);
        }, 500);
    }, [saveResult]);

    const saveHandler = async () => {
        setSaveResult("pending");
        try {
            await request("/api/users/me/mfa", {
                method: "PUT",
                body: JSON.stringify({ use_mfa: mfaEnabled }),
            });
            if (mfaEnabled) {
                Auth.relog();
            }
            await updateUser();
            setSaveResult("success");
        } catch (e) {
            setSaveResult("failure");
        }
    };

    return (
        <>
            <Stack direction="row" justifyContent="space-between" pl={2} pr={2} pt={2} pb={1}>
                <SectionTitle>Account Security</SectionTitle>
                {mfaEnabled !== currentUserMfa && (
                    <SectionTitleIcon direction="row" justifyContent="center" alignItems="center">
                        <IconButton onClick={saveHandler}>
                            <Save color="secondary" fontSize="small" />
                        </IconButton>
                    </SectionTitleIcon>
                )}
            </Stack>
            <CardContainer result={saveResult}>
                <Box p={4}>
                    <Stack direction="column" mb={2} style={{ height: "100%" }}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mfaEnabled}
                                        onChange={() => setMfaEnabled(!mfaEnabled)}
                                    />
                                }
                                label="Enable 2FA"
                            />
                            <SubText>
                                By enabling this you will be logging in using two factor
                                authentication
                            </SubText>
                        </FormGroup>
                    </Stack>
                </Box>
            </CardContainer>
        </>
    );
};

export default MfaSettingsCard;
